import React from 'react';
import YouTube from 'react-youtube';

const YouTubePlayer = ({ controlsInModal }) => {
  const options = {
    playerVars: {}
  }

  let getControls = (controls) => {
    setTimeout(() => {
      controls.playVideo()
    }, 100);
    controlsInModal(controls);
  }

  return (
    <YouTube className="youtubeComponent" videoId="RF9t2rFmTVE" opts={options} onReady={(e) => getControls(e.target)} />
  )
}

export default YouTubePlayer;